// import React from "react";
// import wabco from "../../Images/Wabco.jpg";
// import turbo from "../../Images/Turbo.jpg";
// import rane from "../../Images/Rane.jpg";
// import battery from "../../Images/batteries.jpg";
// import cummins from '../../Images/cummins.jpg';
// import { FaBuilding } from "react-icons/fa";

// const partners = [
//   {
//     type: "Service Center",
//     img: wabco,
//     name: "Janatha Auto Works Authorised Service Center For Wabco",
//     description: "Leading braking and safety solutions provider.",
//     addresses: [
//       "Near RTO Office, Harihar Road, Hospet -583201",
//       "Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, Chitradurga-577501"
//     ],
//     phone: "9008788087, 8884013007"
//   },
//   {
//     type: "Service Center",
//     img: rane,
//     name: "Janatha Auto Works Authorised Service Center For Rane",
//     description: "Trusted manufacturer of auto components.",
//     addresses: [
//       "Near RTO Office, Harihar Road, Hospet -583201",
//       "Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, Chitradurga-577501"
//     ],
//     phone: "9008788087, 9742153614"
//   },
//   {
//     type: "Service Center",
//     img: turbo,
//     name: "Janatha Auto Works Authorised Service Center For Tel Turbo",
//     description: "High-performance turbochargers for vehicles.",
//     addresses: [
//       "Near RTO Office, Harihar Road, Hospet -583201",
//       "Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, Chitradurga-577501"
//     ],
//     phone: "9008788087, 8884013007"
//   },
//   {
//     type: "Distributor",
//     img: battery,
//     name: "Tata Batteries - Janatha Automotives",
//     description: "Reliable automotive and industrial batteries.",
//     addresses: ["#10, Janatha Complex, Near Bala Talkies, Hampi Road, Hospet-583201"],
//     phone: "9591080008"
//   },
//   {
//     type: "Component Care Center",
//     img: cummins,
//     name: "Cummins - Janatha Enterprises",
//     description: "Global leader in diesel and alternative fuel engines.",
//     addresses: [
//       "#10, Janatha Complex, Near Bala Talkies, Hampi Road, Hospet-583201",
//       "Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, Chitradurga-577501"
//     ],
//     phone: "9480722673"
//   }
// ];

// const highlightCity = (text) => {
//   return text.replace(/(Hospet|Chitradurga)/g, '<span class="text-blue-700 font-semibold">$1</span>');
// };

// const Partners = () => {
//   return (
//     <section className="py-16 px-6  bg-gray-100">
//       <div className="flex justify-center items-center gap-2 mb-4 pb-4 text-center">
//         {/* <FaTrophy className="text-blue-500 text-2xl" /> */}
//         <FaBuilding className="text-blue-500 text-2xl" />
//         <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
//           Other<span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800"> Businesses</span>
//         </h2>
//       </div>

//       <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
//         {partners.map((partner, index) => (
//           <div
//             key={index}
//             className="bg-white backdrop-blur-md rounded-2xl shadow-md border border-gray-200 hover:shadow-xl transition p-6 flex flex-col justify-between"
//           >
//             <div className="flex flex-col items-center text-center space-y-4">
//               <img src={partner.img} alt={partner.name} className="w-52 h-24 object-contain mb-4 " />
//               <h3 className="text-lg font-bold text-gray-800">{partner.name}</h3>
//               <span className="mt-1 text-sm text-blue-600 bg-blue-100 rounded-full px-3 py-1">{partner.type}</span>
//               <p className="text-sm text-gray-600 mt-2">{partner.description}</p>
//             </div>

//             <div className="mt-4 border-t border-gray-300 pt-4 text-sm text-gray-700 space-y-2 text-center">
//               {partner.addresses.map((addr, i) => (
//                 <p key={i} dangerouslySetInnerHTML={{ __html: highlightCity(addr) }} />
//               ))}
//               <p className="font-semibold text-gray-800 mt-2">📞 {partner.phone}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Partners;

import React, { useState } from "react";
import wabco from "../../Images/Wabco.jpg";
import turbo from "../../Images/Turbo.jpg";
import rane from "../../Images/Rane.jpg";
import battery from "../../Images/batteries.jpg";
import cummins from '../../Images/cummins.jpg';
import { FaBuilding, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import jaw from '../../Images/jaw-logo.png';

// Data
const partners = [
  {
    type: "Service Center",
    img: wabco,
    name: "Authorised Service Center For Wabco",
    description: "Leading braking and safety solutions provider for commercial vehicles, we ensure road safety.",
    addresses: [
      "Hospet : Near RTO Office, Harihar Road, 583201",
      "Chitradurga : Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, 577501"
    ],
    phone: "Hospet : 9008788087,  Chitradurga : 8884013007"
  },
  {
    type: "Service Center",
    img: rane,
    name: "Authorised Service Center For Rane",
    description: "Trusted manufacturer of auto components. We provide excellent service for Rane products.",
    addresses: [
      "Hospet : Near RTO Office, Harihar Road, 583201",
      "Chitradurga : Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, 577501"
    ],
    phone: "Hospet : 9008788087, Chitradurga : 9742153614"
  },
  {
    type: "Service Center",
    img: turbo,
    name: "Authorised Service Center For Tel Turbo",
    description: "High-performance turbochargers for vehicles. ensuring optimal engine performance.",
    addresses: [
      "Hospet : Near RTO Office, Harihar Road, 583201",
      "Chitradurga : Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, 577501"
    ],
    phone: "Hospet : 9008788087,  Chitradurga : 8884013007"
  },
  {
    type: "Distributor",
    img: battery,
    name: "Tata Batteries - Janatha Automotives",
    description: "Reliable automotive and industrial batteries for all vehicle types with long-lasting power.",
    addresses: ["Hospet :  Janatha Auto Works #10, Janatha Complex, Near Bala Talkies, Hampi Road, 583201"],
    phone: "Hospet : 9591080008"
  },
  {
    type: "Component Care Center",
    img: cummins,
    name: "Cummins - Janatha Enterprises",
    description: "Global leader in diesel and alternative fuel engines. Offering robust power solutions.",
    addresses: [
      "Hospet : Janatha Auto Works , #10, Janatha Complex, Near Bala Talkies, Hampi Road, Hospet-583201",
      "Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, Chitradurga-577501"
    ],
    phone: "Hospet : 6364836900 , Chitradurga : 6364836901"
  },
    {
    type: "Engine Reconditioning",
    img: jaw,
    name: "Engine Reconditioning",
    description: "Commercial vehicle engine restoration & performance enhancement with expert technicians.",
    addresses: [
      "Hospet : Janatha Auto Works , #10, Janatha Complex, Near Bala Talkies, Hampi Road, Hospet-583201",
      "Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, Chitradurga-577501"
    ],
    phone: "9986148034"
  },
   {
    type: "Engine Reconditioning",
    img: jaw,
    name: "Mining Fleet operations",
    description: "Heavy-duty logistics fir NMDC & Bhadra Mines, ensuring efficient material transport.",
    addresses: [
      "Hospet : Janatha Auto Works , #10, Janatha Complex, Near Bala Talkies, Hampi Road, Hospet-583201",
      "Opposite Bapuji High School, NH 13 Road, Pilekeranahalli, Chitradurga-577501"
    ],
    phone: "9880703848"
  },
];

// Helper function for highlighting cities in addresses
const highlightCity = (text) => {
  return text.replace(/(Hospet|Chitradurga)/g, '<span class="text-blue-700 font-semibold">$1</span>');
};

const cardVariants = {
  enter: (direction) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0,
    scale: 0.92,
  }),
  center: {
    x: 0,
    opacity: 1,
    scale: 1,
    transition: { type: "spring", stiffness: 300, damping: 30 }
  },
  exit: (direction) => ({
    x: direction > 0 ? -300 : 300,
    opacity: 0,
    scale: 0.92,
    transition: { duration: 0.2 }
  }),
};

const Partners = () => {
  const [[current, direction], setCurrent] = useState([0, 0]);

  // Loop around carousel
  const nextPartner = () => setCurrent(([curr]) => [(curr + 1) % partners.length, 1]);
  const prevPartner = () => setCurrent(([curr]) => [(curr - 1 + partners.length) % partners.length, -1]);

  // Touch handlers for swipe navigation
  let startX = null;
  const handleTouchStart = (e) => { startX = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (startX != null) {
      const dx = e.changedTouches[0].clientX - startX;
      if (dx > 45) prevPartner();
      if (dx < -45) nextPartner();
      startX = null;
    }
  };

  return (
    <section className="py-16 px-3  bg-gradient-to-br from-gray-900 to-blue-950">
      <div className="flex justify-center items-center gap-2 mb-4 pb-4 text-center">
        <FaBuilding className="text-blue-500 text-2xl" />
        <h2 className="text-3xl md:text-4xl font-bold text-white">
          Other
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800 ml-1">
            Businesses
          </span>
        </h2>
      </div>

      <div className="relative max-w-2xl mx-auto select-none">
        {/* Carousel Card with animation */}
        <div
          className="relative"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <AnimatePresence custom={direction} initial={false}>
            <motion.div
              key={current}
              custom={direction}
              variants={cardVariants}
              initial="enter"
              animate="center"
              exit="exit"
              className="bg-white backdrop-blur-md rounded-2xl shadow-lg border border-gray-200 transition p-6 flex flex-col justify-between min-h-[420px]"
              style={{ minWidth: "320px" }}
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <img src={partners[current].img} alt={partners[current].name} className="w-52 h-24 object-contain mb-4" />
               <h2 className="text-lg md:text-2xl lg:text-3xl font-bold text-blue-700">JANATHA AUTO WORKS</h2>
              <h3 className="text-lg font-bold text-gray-800">{partners[current].name}</h3>
                {/* <span className="mt-1 text-sm text-blue-600 bg-blue-100 rounded-full px-3 py-1">
                  {partners[current].type}
                </span> */}
                <p className="text-sm text-gray-600 mt-2">{partners[current].description}</p>
              </div>
              <div className="mt-4 border-t border-gray-300 pt-4 text-sm text-gray-700 space-y-2 text-center">
                {partners[current].addresses.map((addr, i) => (
                  <p key={i} dangerouslySetInnerHTML={{ __html: highlightCity(addr) }} />
                ))}
                <p className="font-semibold text-gray-800 mt-2">📞 {partners[current].phone}</p>
              </div>
            </motion.div>
          </AnimatePresence>
          {/* Navigation */}
          <button
            aria-label="Previous"
            onClick={prevPartner}
            className="absolute top-1/2 left-0 -translate-y-1/2 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-full w-10 h-10 flex items-center justify-center shadow-md transition z-10"
            style={{ marginLeft: "-2rem" }}
          >
            <FaChevronLeft />
          </button>
          <button
            aria-label="Next"
            onClick={nextPartner}
            className="absolute top-1/2 right-0 -translate-y-1/2 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-full w-10 h-10 flex items-center justify-center shadow-md transition z-10"
            style={{ marginRight: "-2rem" }}
          >
            <FaChevronRight />
          </button>
        </div>
        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {partners.map((_, i) => (
            <button
              key={i}
              className={`w-3 h-3 rounded-full ${i === current ? "bg-blue-700" : "bg-blue-300"} transition`}
              onClick={() => setCurrent([i, i > current ? 1 : -1])}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
